var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.388 9.82261C19.3232 10.0047 20.1827 10.4612 20.8565 11.1337C21.5302 11.8062 21.9876 12.664 22.1701 13.5974M18.388 6C20.331 6.21544 22.1429 7.08388 23.5261 8.46272C24.9093 9.84157 25.7817 11.6489 26 13.5879M25.0425 21.214V24.0809C25.0436 24.3471 24.989 24.6105 24.8821 24.8544C24.7753 25.0983 24.6186 25.3172 24.4221 25.4971C24.2256 25.677 23.9937 25.814 23.7411 25.8993C23.4885 25.9845 23.2208 26.0162 22.9552 25.9922C20.0089 25.6727 17.1787 24.6678 14.6921 23.0584C12.3787 21.5911 10.4173 19.6335 8.94724 17.3245C7.32908 14.8314 6.32206 11.9929 6.00777 9.03897C5.98384 8.7747 6.01531 8.50836 6.10017 8.25689C6.18503 8.00543 6.32141 7.77435 6.50065 7.57838C6.67989 7.3824 6.89804 7.22582 7.14123 7.11861C7.38442 7.0114 7.64731 6.9559 7.91316 6.95565H10.7856C11.2503 6.95109 11.7008 7.11532 12.0531 7.41774C12.4054 7.72016 12.6355 8.14013 12.7006 8.59937C12.8218 9.51686 13.0467 10.4177 13.3708 11.2848C13.4996 11.6268 13.5275 11.9985 13.4511 12.3559C13.3748 12.7133 13.1974 13.0414 12.9399 13.3012L11.7239 14.5149C13.087 16.9074 15.0717 18.8883 17.4688 20.2488L18.6848 19.0351C18.9452 18.7782 19.2738 18.6011 19.6319 18.5249C19.99 18.4486 20.3624 18.4765 20.7051 18.6051C21.5738 18.9286 22.4764 19.153 23.3956 19.274C23.8608 19.3395 24.2855 19.5733 24.5892 19.931C24.8928 20.2887 25.0542 20.7453 25.0425 21.214Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Active);
export default __webpack_public_path__ + "static/media/step2-active.7640923735650a62b1f345bc4425bbda.svg";
export { ForwardRef as ReactComponent };